import React, { useReducer, useEffect } from "react";
import { Redirect, useLocation } from "react-router-dom";

import {
  Row,
  Col,
  Label,
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
} from "reactstrap";

import { connect } from "react-redux";
import { setRedirect } from "../../../redux/actions/redirect";

import { showToast } from "../../../helpers/toast";

import Banner from "../../../components/Banner";
import Select from "react-select";

import {
  fetchQualifications,
  fetchSubjectsByQualification,
} from "../../../redux/actions/api_subject";
import Loader from "../../../components/Loader";
import { createLoadingSelector } from "../../../redux/selectors";

const ClassRequestForm = ({
  fetchQualifications,
  fetchSubjectsByQualification,
  auth,
  setRedirect,
  qualifications,
  classQualification,
  subjects,
  isLoading,
  isLoadingSubjects,
}) => {
  const initialState = {
    classQualification: classQualification && classQualification.id,
    studentName: "",
    remarks: "",
    count: "10",
    subjects: [],
    subjects_select: [],
  };

  const reducer = (state, newState) => ({ ...state, ...newState });
  const [state, setState] = useReducer(reducer, initialState);

  useEffect(() => {
    fetchQualifications();
    classQualification && fetchSubjectsByQualification(classQualification.id);
  }, [fetchQualifications, classQualification, fetchSubjectsByQualification]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (isNaN(value)) {
      setState({ [name]: value });
    } else {
      setState({ [name]: parseInt(value) });
    }
    console.log(state);
  };

  const handleChangeQualification = (e) => {
    fetchSubjectsByQualification(e.target.value);
    handleChange(e);
    setState({ subjects: [], subjects_select: [] });
  };

  const handleChangeSubjects = (selectedOption) => {
    const arr =
      selectedOption && selectedOption.length
        ? selectedOption.map((option) => {
            return { id: option.value };
          })
        : [];

    setState({ subjects: arr, subjects_select: selectedOption });
  };

  const handleCheck = (e) => {
    const { value } = e.target;
    setState({ count: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // createClassRequest(state);
  };

  let location = useLocation();

  if (isLoading) {
    return <Loader />;
  }

  if (!auth.isAuthenticated) {
    showToast("로그인 해주세요.", "", "warning");
    setRedirect(location.pathname);
    return <Redirect to="/auth/login" />;
  }

  return (
    <React.Fragment>
      <Banner
        title="수강 신청"
        subtitle={classQualification && classQualification.name}
        bg="banner2.jpg"
      />
      <div className="site-section" style={{ paddingTop: 0 }}>
        <Container>
          <Row>
            <Col md={12}>
              <Card className="mb-3">
                <CardBody>
                  <Form onSubmit={handleSubmit}>
                    <Row className="p-sm-4">
                      <Col md={6}>
                        <FormGroup>
                          <Label>과정</Label>
                          <Input
                            type="select"
                            name="classQualification"
                            id="classQualification"
                            defaultValue={
                              classQualification && classQualification.name
                            }
                            onChange={handleChangeQualification}
                          >
                            {qualifications &&
                              qualifications.map((qualification) => (
                                <option
                                  value={qualification.id}
                                  key={qualification.id}
                                >
                                  {qualification.name}
                                </option>
                              ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label>과목 선택</Label>
                          <Select
                            name="subjects"
                            onChange={handleChangeSubjects}
                            isMulti
                            isSearchable
                            placeholder={
                              isLoadingSubjects ? "로딩중..." : "과목 선택"
                            }
                            value={state.subjects_select}
                            options={subjects}
                            isDisabled={!subjects || isLoadingSubjects}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12}>
                        <FormGroup>
                          <Label>학생 이름</Label>
                          <Input
                            bsSize="md"
                            type="text"
                            name="studentName"
                            onChange={handleChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} className="mb-3">
                        <FormGroup className="mb-0">
                          <Label>
                            강의 횟수{" "}
                            <small className="muted">(과목 1개 기준)</small>
                          </Label>
                        </FormGroup>
                        <FormGroup check inline>
                          <Label check className="font-weight-light">
                            <Input
                              type="radio"
                              value="10"
                              onChange={handleCheck}
                              checked={state.count === "10"}
                            />{" "}
                            10 회
                          </Label>
                        </FormGroup>
                        <FormGroup check inline>
                          <Label check className="font-weight-light">
                            <Input
                              type="radio"
                              value="30"
                              onChange={handleCheck}
                              checked={state.count === "30"}
                            />{" "}
                            30 회
                          </Label>
                        </FormGroup>
                        <FormGroup check inline>
                          <Label check className="font-weight-light">
                            <Input
                              type="radio"
                              value="60"
                              onChange={handleCheck}
                              checked={state.count === "60"}
                            />{" "}
                            60 회
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col md={12}>
                        <FormGroup>
                          <Label>비고</Label>
                          <Input
                            type="textarea"
                            name="extra"
                            onChange={handleChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} className="text-center">
                        <Button
                          className="w-100"
                          type="submit"
                          color="info"
                          size="md"
                        >
                          수강 신청하기
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

const loadingSelector = createLoadingSelector([
  "FETCH_AUTHUSER",
  "FETCH_QUALIFICATIONS",
]);
const loadingSubjectsSelector = createLoadingSelector(["FETCH_SUBJECTS"]);

const mapStateToProps = (state) => ({
  auth: state.api_auth,
  isLoading: loadingSelector(state),
  isLoadingSubjects: loadingSubjectsSelector(state),
  qualifications: state.api_subject.qualifications,
  classQualification: state.class_request_form.qualification,
  subjects: state.api_subject.subjects_multi_select,
});

const mapDispatchToProps = (dispatch) => ({
  setRedirect: (path) => dispatch(setRedirect(path)),
  fetchQualifications: () => dispatch(fetchQualifications()),
  fetchSubjectsByQualification: (qualification) =>
    dispatch(fetchSubjectsByQualification(qualification)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClassRequestForm);
